/*============================================================================
  Accordion Products Page
==============================================================================*/
$(function() {
  var allPanels = $('.accordion > dd').hide();

  $('.accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(":visible")) {
      $(this).find('small.left').html('&#9660;');
      $(this).parent().next().slideDown();

    } else if($(this).parent().next().is(":visible")){
      $(this).parent().next().slideUp();
      $(this).parent().next().removeClass('isVisible').addClass('noVisible');
      $(this).parent().next('.accordion small.left').html('&#x25B6;');
      $(this).next('small.left').html('&#x25B6;');
      if($(this).find('small.left').html('&#x25B6;;')) {
        $(this).find('small.left').html('&#x25B6;');
      } else if($(this).find('small.left').html('&#x25B6;')) {
        $(this).find('small.left').html('&#x25B6;');
      }
    }
    return false;
  });
});

